import React from 'react'

import { defaultStyles as styles } from '../styles'
export const ExperienceTab = () => {
  return (
    <>
      <div style={styles.flexBox}>
        <div style={styles.flexBoxBasis(270)}>
          <p style={styles.sectionTitle}>Education</p>
          <p style={{ ...styles.contentItem, ...styles.contentItemMb }}>
            The Brody School of Medicine at East Carolina University
          </p>
          <p style={{ ...styles.contentItem, ...styles.contentItemMb }}>
            Residency, Family Medicine, 2005 Ross University School of Medicine
          </p>
          <p style={styles.contentItem}>
            Medical School, 2002
          </p>
        </div>

        <div style={styles.flexBoxBasis(220)}>
          <p style={styles.sectionTitle}>Certifications</p>
          <p style={styles.contentItem}>AB Family Medicine-General Board Certification</p>
        </div>
      </div>
    </>
  )
}
